export const normalizeGroupName = (name: string = '') => name.trim().toLowerCase().replace(/\s+/g, ' ');